import {Component, ElementRef, Input} from '@angular/core';
import { MapDataService } from '../map-data.service';
import { TransformGroup, FourdCesiumHelper,Transform, Annotation, PlottableModel } from '4d-mapper';
import { MapEventService } from '../map-event.service';
import { Subscription } from 'rxjs';
import { CameraDirection, LayerEvent, PhotoEvent, AnnotationEvent } from '../map-event.objects';
import { CesiumCoordinate } from './cesium-map-objects';

import { AnnotationType } from '../../../commons/global';
import { GeomAnnotationRenderer } from './cesium-renderer-geom';
import { PinAnnotationRenderer } from './cesium-renderer-pin';
import { environment } from '../../../../environments/environment';
import { WMSTransformRenderer } from './cesium-renderer-wms';


const Cesium = (<any>window).Cesium


@Component({
  selector: 'fourd-map-view-component,[fourd-map-view-component]',
  template: ``
})
export class FourDMapComponent {

  screenOffset = {x:0,y:0}


  private viewer: any
  private mapHelper: FourdCesiumHelper
  private handler: any

  // cesium object for cursor pointer and datasource
  private _cursorMeta:any
  private _cursorDataSource:any

  // moving into baseComponent
  private _subs:Subscription[] = []

  constructor(private elm: ElementRef, private mapData:MapDataService,private mapEvents:MapEventService, private elem:ElementRef) {
    // Cesium.BingMapsApi.defaultKey = undefined
  }

  ngOnInit() {

    console.log ('/v2 --- cesiumMapComponent :: onInit()');

    // init ceisum
    this.initCesium()
    // conncet it to the MapHelper
    this.mapHelper = new FourdCesiumHelper(this.mapData.fourD,this.viewer)
    // conncet the renderers to the MapHelper
    this.mapHelper.registerRenderer(Annotation, AnnotationType.poi,new PinAnnotationRenderer(this.mapHelper))
    this.mapHelper.registerRenderer(Annotation,'*',new GeomAnnotationRenderer(this.viewer))
    this.mapHelper.registerRenderer(Transform,'wms-remote',new WMSTransformRenderer(this.viewer))
    this.mapHelper.registerRenderer(Transform,'arcgis-remote',new WMSTransformRenderer(this.viewer))

    // assign it to the map event service for anyone else who might care
    this.mapEvents.map.value = this.mapHelper

    // cursor object
    this.initCursor()

    // connect mouse click events
    this.handler = new Cesium.ScreenSpaceEventHandler(this.elm.nativeElement);

    // the Cesium right/left click handler connected to the 4D Mapper click handler
    this.handler.setInputAction(movement => this.clickHandler(movement, true), Cesium.ScreenSpaceEventType.RIGHT_CLICK);
    this.handler.setInputAction(movement => this.clickHandler(movement, false), Cesium.ScreenSpaceEventType.LEFT_CLICK);

    // send start and end camera pan events
    this.viewer.scene.camera.moveStart.addEventListener(ev => this.mapEvents.cameraStartingMove())
    this.viewer.scene.camera.moveEnd.addEventListener(ev => {
      this.mapEvents.camera.value = this.cameraPostion()
      // on end event update the 2d coordinates using the cesium scene object
      if(this.mapEvents.cursor.value && this.mapEvents.cursor.value.coodinate instanceof CesiumCoordinate)
        this.mapEvents.cursor.value.coodinate.setScreen(this.viewer.scene)
        
    })

    // map data streams (to draw data from server on the map)
    this._subs.push(this.mapData.displayedLayers.events.subscribe(l => this.onLayerChange(l)))
    this._subs.push(this.mapData.displayedAnnotations.events.subscribe(annot => this.onAnnotsChanged(annot)))
    this._subs.push(this.mapData.displayedPhotos.events.subscribe(annot => this.onPhotosChanges(annot)))

    // map event streams (to move camrea and cursor)
    this._subs.push(this.mapEvents.camera.events.subscribe(cam => {
      // willmove is the request to move
      if(cam.event == 'request_move'){
        if(cam.item instanceof PlottableModel){
          var dur = cam.args && cam.args.duration?cam.args.duration:1000
          this.mapHelper.sendCameraTo(cam.item,dur)
        }
        // if its a camera position
        else
          console.error('No supported yet')
      }
    }))

    this._subs.push(this.mapEvents.cursor.events.subscribe(s => {
      if(s.event == 'UPDATE'){
        this._cursorMeta.position = (<CesiumCoordinate>s.item.coodinate).cartesian
        // this demo its not actually an icon rather a coulor
        if(s.item.icon){
          var color = Cesium.Color[s.item.icon].withAlpha(0.5)
      
          this._cursorMeta.point = {
              pixelSize : 30,
              color :color
            }
        }

      } 
      else if(s.event == 'REMOVE'){
        this._cursorMeta.position = null
      }
    }))

    // figure out screen offset (for context menus)
    this.screenOffset = this.getScreenOffsetPos(this.elem.nativeElement)
  }
  
  private initCesium(){

    console.log ('/v2 --- cesiumMapComponent :: initCesium()');

    // Cesium.BingMapsApi.defaultKey = undefined
    var mapboxApiKey = 'pk.eyJ1IjoiZ2VvbWF0aWNzIiwiYSI6IjRDSmd3UWcifQ.YEoSImxSElTq1uPwjZnrNw';
    var mappy = new Cesium.MapboxImageryProvider({
      url: 'https://api.mapbox.com/v4',
      mapId: 'mapbox.satellite',
      accessToken: mapboxApiKey,
      maximumLevel: 16,
      minimumLevel: 0
    });

    this.viewer = new Cesium.Viewer(this.elm.nativeElement, {
      homeButton: false,
      sceneModePicker: false,
      navigationInstructionsInitiallyVisible: false,
      geocoder: false,
      baseLayerPicker: false,
      navigationHelpButton: false,
      fullscreenButton: false,
      timeControlsInitiallyVisible: false,
      scene3DOnly: true,
      showRenderLoopErrors: environment.production,
      imageryProvider: mappy,

      //NOTE: disable Cesium/leaflet timelines/animations until further notice
      timeline: false,
      animation: false,
      selectionIndicator: false,
      infoBox: false,
      /*terrainProvider: Cesium.createWorldTerrain({
        requestWaterMask : true,
        requestVertexNormals: true // true //Needed to visualize slope
      })*/
      shouldAnimate: true
    })
    this.viewer.scene.globe.depthTestAgainstTerrain = true;
    this.viewer.scene.frameState.creditDisplay.container.remove();
    //Set the time to position of the sun
    this.viewer.clock.currentTime = Cesium.JulianDate.fromDate(new Date());
    this.viewer.clock.multiplier = 1;
    this.viewer.clock.shouldAnimate = true;



    
  }

  /**
   * This code defines the cursors appearance the cesium specific way
   */
  private initCursor(){
    this._cursorDataSource = new Cesium.CustomDataSource('annot');
    this.viewer.dataSources.add(this._cursorDataSource)
		
    var color = Cesium.Color.PURPLE.withAlpha(0.5)
    
    var cursorConf = {
      name:'cursor',
      point : {
        pixelSize : 30,
        color :color
      }
    }
    
    this._cursorMeta = this._cursorDataSource.entities.add(cursorConf)
  }


  /**
   * this handles the map clicks the cesium specific way, and routes them to the mapEvents using the abstact way
   * @param movement 
   * @param right 
   */
  clickHandler(movement,right){

    // create a cartesian position object from our position coords
    const cartesian = this.viewer.scene.pickPosition(movement.position);

    // make 4D Mapper version of a coordinate
    const cood = CesiumCoordinate.catersianToCoord(cartesian,movement.position)

    var item = this.mapHelper.resolveItem(movement)
   
    this.mapEvents.onMapClicked(cood,item,right)

  }
  ngOnDestroy() {
   // this.viewer.destroy()
    this.mapEvents.map.value = null
    this._subs.forEach(s => s.unsubscribe())
  }





  /**
   * Take objects on and off scene
   * @param grop 
   */
  private onLayerChange(l:LayerEvent){
    
    // if its update lets look at things like allowed to plot etc
    if(l.event == 'ADD' || l.event == 'UPDATE')
   
        this.mapHelper.setPlottable(l.item).subscribe(_ => 
          // if theres opacity levels
          this.mapHelper.changeOpacity(l.item, (this.mapData.scene.value || this.mapData.loadingScene.value).getAlpha(l.item))
        )

    else if(l.event == 'REMOVE' )
        this.mapHelper.removePlottable(l.item)
    
      
  }

  /**
   * Take annotations on and off
   * @param grop 
   */
  private onPhotosChanges(l:PhotoEvent){
    // if ite delete then remove
    if( l.event == 'REMOVE')
    this.mapHelper.removePlottable(l.item)
  
   // if its update l
   else if(l.event == 'UPDATE' || l.event == 'ADD'){
     this.mapHelper.setPlottable(l.item).subscribe()
   }
 }
   /**
   * Take annotations on and off
   * @param grop 
   */
  private onAnnotsChanged(l:AnnotationEvent){
     // if ite delete then remove
     if( l.event == 'REMOVE')
     this.mapHelper.removePlottable(l.item)
   
    // if its update l
    else if(l.event == 'UPDATE' || l.event == 'ADD'){
      this.mapHelper.setPlottable(l.item).subscribe()
    }
  }

  /**
   * get 4D Mapper camera position object from cesium sepcific one
   */
  private cameraPostion():CameraDirection{
    var pos = new CesiumCoordinate(this.viewer.scene.camera.position)
    pos.setScreen(this.viewer.scene)
    return {
      position:pos,
      heading:this.viewer.scene.camera.heading,
      pitch:this.viewer.scene.camera.pitch,
      roll:this.viewer.scene.camera.roll
    }

  }

  /**
   * get the total offset of the cesium component
   * @param el 
   */
  private getScreenOffsetPos(el) {
    el = el.children[0]
    var top = 0
    for(var cur = el.parentNode; cur != null ; cur = cur.parentNode)
      if(!isNaN(cur.scrollTop ))
        top += cur.scrollTop
    
    for (var lx=0, ly=0;
         el != null;
         lx += el.offsetLeft, ly += el.offsetTop, el = el.offsetParent);
    return {x: lx ,y: ly - top};
  }
}

